<kendo-tabstrip fxFlex="1 1 auto">
   <kendo-tabstrip-tab [selected]="true">
      <ng-template kendoTabTitle>
         <fa-icon class="sam-margin-right" [icon]="categoryIconCommon"></fa-icon>
         {{ 'common.global_settings.categories.common' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-common-settings></samweb-common-settings>
      </ng-template>
   </kendo-tabstrip-tab>
   <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
         <fa-icon class="sam-margin-right" [icon]="categoryIconBrickwall"></fa-icon>
         {{ 'common.global_settings.categories.brickwall' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-brickwall-settings></samweb-brickwall-settings>
      </ng-template>
   </kendo-tabstrip-tab>
   <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
         <fa-icon class="sam-margin-right" [icon]="categoryIconKeyboard"></fa-icon>
         {{ 'common.global_settings.categories.keyboard' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-keyboard-settings></samweb-keyboard-settings>
      </ng-template>
   </kendo-tabstrip-tab>
   <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
         <fa-icon class="sam-margin-right" [icon]="categoryIconAudio"></fa-icon>
         {{ 'common.global_settings.categories.audio' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-audio-settings></samweb-audio-settings>
      </ng-template>
   </kendo-tabstrip-tab>
   <kendo-tabstrip-tab *ngIf="canChangeOwnPassword$ | async">
      <ng-template kendoTabTitle>
         <fa-icon class="sam-margin-right" [icon]="categoryIconPassword"></fa-icon>
         {{ 'common.change-password.title' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-user-password></samweb-user-password>
      </ng-template>
   </kendo-tabstrip-tab>
   <kendo-tabstrip-tab>
      <ng-template kendoTabTitle>
         <samweb-icon-with-subicon
            class="sam-margin-right sam-small-font-size sam-center"
            [primaryIcon]="categoryIconAnnouncementPrimary"
            [secondaryIcon]="categoryIconAnnouncementSecondary"
         ></samweb-icon-with-subicon>
         {{ 'common.settings.agent_greetings.tab_title' | translate }}
      </ng-template>
      <ng-template kendoTabContent>
         <samweb-greeting-settings></samweb-greeting-settings>
      </ng-template>
   </kendo-tabstrip-tab>
</kendo-tabstrip>

<div fxLayout="row" fxFlexAlign="end" fxLayoutGap="5px" class="sam-margin">
   <button kendoButton [primary]="true" (click)="saveSettings()">
      <fa-icon class="sam-margin-right" [icon]="saveIcon"></fa-icon>
      <div class="sam-button-text">
         {{ 'common.global_settings.save_button' | translate }}
      </div>
   </button>
   <button kendoButton (click)="cancelSettings()">
      <fa-icon class="sam-margin-right" [icon]="cancelIcon"></fa-icon>
      <div class="sam-button-text">
         {{ 'common.global_settings.cancel_button' | translate }}
      </div>
   </button>
</div>
